module.exports = __webpack_public_path__ + "static/img/qizhi.6ed0c550.png";